import { Button, makeStyles, useTheme } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styles } from './notFoundError.styles';

export interface NotFoundErrorProps {
  email?: string;
  onRefresh?: () => void;
  onReportError?: () => void;
  onLogout?: () => void;
}

export const NotFoundError: React.FC<NotFoundErrorProps> = props => {
  const [t] = useTranslation(['httpErrors']);
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  return (
    <div className={classes.errorContainer}>
      <div className={classes.errorCode}>
        <img
          alt="Globaleris"
          src={process.env.PUBLIC_URL + '/images/globaleris-error-notFound.png'}
        />
      </div>
      <div className={classes.errorDescription}>
        <h1>{t('httpErrors:notFound.title')}</h1>
        <p>
          {t('httpErrors:notFound.subtitle')}
          <br />
          {t('httpErrors:notFound.text')}
        </p>
        <p>{t('httpErrors:notFound.userInfo', { email: props.email })}</p>
        {props.onRefresh && (
          <Button
            className={classes.actionButton}
            variant="contained"
            color="primary"
            onClick={() => {
              props.onRefresh && props.onRefresh();
            }}
          >
            {t('httpErrors:notFound.actions.refresh')}
          </Button>
        )}
        {props.onReportError && (
          <Button
            color="primary"
            className={classes.actionButton}
            onClick={() => {
              props.onReportError && props.onReportError();
            }}
          >
            {t('httpErrors:notFound.actions.report')}
          </Button>
        )}
        {props.onLogout && (
          <Button
            color="primary"
            className={classes.actionButton}
            onClick={() => {
              props.onLogout && props.onLogout();
            }}
          >
            {t('httpErrors:notFound.actions.logout')}
          </Button>
        )}
      </div>
    </div>
  );
};
